import { IAdminCreateAccount } from './createAccount.interface';
import { CreateAccountTypes } from './createAccount.type';


export const createAccount = (payload: IAdminCreateAccount) => ({
	type: CreateAccountTypes.ADMIN_CREATE_ACCOUNT,
	payload
})
